import React, { FC } from "react";
import facebookSvg from "images/Facebook.svg";
import googleSvg from "images/Google.svg";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Sheet from "react-modal-sheet";
import OtpInput from "react-otp-input";
import { useTranslation } from "react-i18next";
import useLoginByGoogle from "hooks/useLoginByGoogle";
import useLoginByPhone from "hooks/useLoginByPhone";

export interface LoginPageProps {
  className?: string;
}

const loginSocials = [
  {
    name: "continue_with_facebook",
    href: "#",
    icon: facebookSvg,
  },
  {
    name: "continue_with_google",
    href: "#",
    icon: googleSvg,
  },
];

const LoginPage: FC<LoginPageProps> = ({ className = "" }) => {
  const { _onGoogleLogin } = useLoginByGoogle();

  const { phone, isShowPopUp, code, isRecaptchaVerifierLoading, setPhone, setIsShowPopUp, setCode, _onPhoneLogin } = useLoginByPhone();

  const { t } = useTranslation();

  return (
    <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
      <Helmet>
        <title>Flying Lab - 登入</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">{t("signin")}</h2>
        <div className="max-w-md mx-auto space-y-6">
          {/* <div className="grid gap-3">
            {loginSocials.map((item, index) => (
              <a
                key={index}
                href={item.href}
                onClick={_onGoogleLogin}
                className="nc-will-change-transform flex w-full rounded-lg bg-primary-50 dark:bg-neutral-800 px-4 py-3 transform transition-transform sm:px-6 hover:translate-y-[-2px]">
                <img className="flex-shrink-0" src={item.icon} alt={item.name} />
                <h3 className="flex-grow text-center text-sm font-medium text-neutral-700 dark:text-neutral-300 sm:text-sm">{t(item.name)}</h3>
              </a>
            ))}
          </div> */}
          {/* OR */}
          {/* <div className="relative text-center">
            <span className="relative z-10 inline-block px-4 font-medium text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">{t("or")}</span>
            <div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 border border-neutral-100 dark:border-neutral-800"></div>
          </div> */}
          {/* FORM */}
          <form className="grid grid-cols-1 gap-6" onSubmit={_onPhoneLogin}>
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">{t("phone")}</span>
              <Input type="number" value={`${phone}`} onChange={(e) => setPhone(e.target.value)} placeholder="" className="mt-1" />
            </label>

            <ButtonPrimary loading={isRecaptchaVerifierLoading} disabled={phone.length == 0 || isRecaptchaVerifierLoading} type="submit">
              {t("continue")}
            </ButtonPrimary>
          </form>
          <div id="recaptcha-container" className="justify-center flex"></div>
          <Sheet isOpen={isShowPopUp} onClose={() => setIsShowPopUp(false)}>
            <Sheet.Container>
              <Sheet.Header />
              <Sheet.Content>
                <div className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                  <div className="items-center w-4/5 lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
                    <div className="listingSection__wrap">
                      <div>
                        <h2 className="text-2xl font-semibold">{t("sms_verify_title")}</h2>
                        <span className="block mt-2 text-neutral-500 dark:text-neutral-400">{t("sms_verify_desc")}</span>
                      </div>

                      <OtpInput
                        value={code}
                        onChange={setCode}
                        numInputs={6}
                        renderInput={(props, index) => (
                          <input
                            autoFocus={index === 0}
                            {...props}
                            style={{
                              paddingLeft: 0,
                              paddingRight: 0,
                              height: "50px",
                              backgroundColor: "transparent",
                              outline: "none",
                              textAlign: "center",
                              fontSize: "18px",
                              fontWeight: "bold",
                              color: "#4a90e2", // Blue text color
                              margin: "0 2%", // Horizontal padding of 5%
                              borderRadius: "8px", // Rounded corners
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop />
          </Sheet>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
